<template>
    <v-content>  
      <v-alert type="warning" class="mx-auto col-6" justify="center"  >
          Esta página no es accesible directamente
    </v-alert>
    </v-content>
</template>


<script>
  export default {
      name: 'EmptyMain',
    data () {
      return {
       //
      }
    },
  }
</script>